import React from 'react'
import './Terms.css';
// import {helmet} from "react-helmet";

export default function TermsConditions() {
  return (
    <>
    <div class="terms-hero">
      <helmet>
    <title>Terms and Conditions | Shivam Digital</title>
    <meta name="description" content="Review the terms and conditions that govern the use of Shivam Digital's freelance services and website." />
    <meta name="keywords" content="Terms and Conditions, User Agreement, Website Terms, Freelance Service Terms, Shivam Digital Legal Terms, Service Policy" />


      </helmet>
  <h1>Terms & Conditions</h1>
</div>

<section class="terms-content">
  <div class="terms-container">
    <p><strong>Last Updated:</strong> July 25, 2025</p>

    <h2>1. Agreement to Terms</h2>
    <p>By accessing or using our website (shivamdigital.com), you agree to be bound by these Terms & Conditions. If you disagree, please do not use our services.</p>

    <h2>2. Services Offered</h2>
    <p>Shivam Digital provides freelance digital services including website development, social media management, and digital marketing. Service details, pricing, and timelines will be discussed and agreed upon before engagement.</p>

    <h2>3. User Responsibilities</h2>
    <p>You agree to provide accurate information, comply with all applicable laws, and not misuse or disrupt our website or services.</p>

    <h2>4. Payments and Refunds</h2>
    <p>All payments must be made as agreed. Due to the nature of digital services, refunds may not be applicable once a project begins, unless otherwise agreed.</p>

    <h2>5. Intellectual Property</h2>
    <p>All content on this website is owned by or licensed to Shivam Digital. You may not copy, reproduce, or use any content without permission.</p>

    <h2>6. Limitation of Liability</h2>
    <p>We are not liable for any indirect, incidental, or consequential damages arising from your use of the site or services.</p>

    <h2>7. Termination</h2>
    <p>We may suspend or terminate access to our site/services without notice if you violate these terms.</p>

    <h2>8. Changes to Terms</h2>
    <p>We reserve the right to update these terms at any time. Continued use of the site indicates acceptance of the revised terms.</p>

    <h2>9. Contact</h2>
    <p>If you have questions about these terms, contact us at <a href="mailto:shivamraj1342@gmail.com">shivamraj1342@gmail.com</a>.</p>
  </div>
</section>

    </>
  )
}
